<template>
  <DatePicker
    v-model="date"
    :label="$tt('passport_issue_date')"
    :min="getYearsAgoIso(20)"
    past
  />
</template>

<script setup lang="ts">
import { getYearsAgoIso } from '~/helpers/date';
import type { DateISO } from '~/types';

const date = defineModel<DateISO>({ required: true });
</script>